<!-- prettier-ignore -->
@if(datasource){
    <h3 class="category-title" (click)="goToSubCategoriesList(item.category)">
        {{item.category?.name?.[translate.currentLang]}} >>
    </h3>
    
    <div #eventContainer class="cardsScrollContainer items-scroll-wrapper">
        <span #leftArrow class="item-arrow-left eventGoLeft" scrollControl> < </span>
        <span #rightArrow class="item-arrow-right eventGoRight" scrollControl> > </span>
    
        <div class="viewport horizontal eventContainer" scrollControl>
            <div *uiScroll="let datasourceItem of datasource">
                <div class="item horizontal">
                  @if(datasourceItem.type === 'item'){
                    <cicerone-generic-card [item]="datasourceItem.data" />
                  }
                  @if(datasourceItem.type === 'more'){
                    <cicerone-generic-card (click)="goToSubCategoriesList(item.category)" [seeMore]="true" />
                  }                
                </div>
            </div>
            <!-- <div class="item horizontal">
                <cicerone-generic-card (click)="goToSubCategoriesList(item.category)" [seeMore]="true" />
            </div> -->
        </div>
        
    </div>
}